var textTransformMap = {
    none: "none",
    capitalize: "capitalize",
    uppercase: "uppercase",
    lowercase: "lowercase",
    firstLetter: "firstLetter",
    fullWidth: "full-width",
};
var textTransform = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.textTransform, textTransform = _c === void 0 ? textTransformMap.none : _c;
    if (textTransform === textTransformMap.firstLetter)
        return "text-transform: lowercase;\n    &::first-letter {\n      text-transform: uppercase;\n    }\n";
    return textTransform in textTransformMap
        ? "text-transform: ".concat(textTransformMap[textTransform], ";")
        : "text-transform: ".concat(textTransformMap.none, ";");
};
export default textTransform;
